<template>
  <div class="ept-search-box__container">
    <div v-if="isOpen">
      <form ref="form" action="/busca" method="GET">
        <div class="ept-search-box__wrapper space-x-2" :class="{ 'active': isOpen }">
          <button type="button" class="ept-search-box__back" @click.prevent="closeField" aria-label="Voltar">
            <i class="far fa-arrow-left text-xl" aria-hidden="true"></i>
          </button>

          <input ref="input" name="q" type="text" class="ept-search-box__input" placeholder="Digite aqui o que procura" />

          <button class="ept-search-box__confirm" @click.prevent="submitForm" aria-label="Buscar">
            <i class="far fa-search text-xl" aria-hidden="true"></i>
          </button>
        </div>
      </form>
    </div>

    <button class="header__link mr-0 flex-none"
            :class="{ 'header__link--white': inverse, 'header__link--primary': !inverse }"
            @click.prevent="openField" aria-label="Buscar">
      <i class="far fa-search text-2xl lg:text-base" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'HeaderFieldSearch',

  props: {
    inverse: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isOpen: false
  }),

  methods: {
    closeField() {
      this.isOpen = false
    },

    openField() {
      this.isOpen = true
      this.$nextTick(() => this.$refs.input.focus())
    },

    submitForm() {
      this.$refs.form.submit()
    },

    toggleField() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~stylesheets/vars";
@import '~stylesheets/header/site.scss';

.ept-search-box {
  &__back {
    @extend .header__link;
    @extend .header__link--primary;
    display: inline-flex;
    align-items: center;
    @apply flex-none;
    @apply mr-0;
  }

  &__confirm {
    @extend .header__link;
    @extend .header__link--primary;
    display: inline-flex;
    align-items: center;
    @apply flex-none;
    @apply mr-0;
  }

  &__container {
    min-width: 1.5rem;
    display: flex;
    align-items: center;
  }

  &__wrapper {
    position: absolute;
    z-index: 1;
    top: 0;
    right: -100%;
    width: calc(100vw - 3rem);
    display: flex;
    align-items: center;
    border: 1px solid $stroke-gray;
    background: white;

    @apply my-3;
    @apply mx-6;
    @apply p-2;

    transition: 0.4s;

    &.active {
      left: 0;
      top: 0;
    }

    @screen lg {
      @apply p-4;
    }
  }

  &__input {
    flex-grow: 1;

    @apply text-gray-700;
    @apply text-base;
    @apply leading-tight;

    border: none;
    background: none;
    outline: none;
    padding: 0;
  }
}

// .search-box.active > .search-txt {
//   width: calc(calc(100vw - 4rem) - 2.5rem);
//   padding: 0 1rem;
// }

// .search-btn {
//   @apply text-primary;
//   float: right;
//   width: 2.5rem;
//   height: 2.5rem;
//   background: none;
//   outline: none;

//   display: flex;
//   justify-content: center;
//   align-items: center;
//   transition: 0.4s;
// }
</style>
